const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Licensed & Insured',
    description: 'Fully licensed and insured for your peace of mind'
  },
  {
    icon: 'ri-time-line',
    title: 'Reliable Service',
    description: 'On-time arrivals and efficient project completion'
  },
  {
    icon: 'ri-star-line',
    title: 'Quality Workmanship',
    description: 'Attention to detail and superior craftsmanship'
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Fair Pricing',
    description: 'Competitive rates with transparent quotes'
  }
];

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              Why Choose <strong>Handyman of Stillwater</strong>?
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With years of experience serving the Stillwater community and surrounding areas, we've built our reputation on quality work, honest pricing, and exceptional customer service. Whether it's a small repair or a major home improvement project, we treat every job with the same level of care and professionalism.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Our team of skilled professionals is dedicated to making your home improvement experience stress-free. We understand that your home is your most valuable investment, and we're committed to helping you maintain and enhance it with reliable, high-quality handyman services.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                    <i className={`${feature.icon} text-2xl text-teal-600`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[600px] w-full">
              <img 
                src="https://public.readdy.ai/ai/img_res/86260317c2794943a24be44120577d26.jpg"
                alt="Handyman of Stillwater Team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-teal-600 text-white p-8 rounded-xl shadow-xl max-w-xs">
              <div className="text-5xl font-bold mb-2">15+</div>
              <div className="text-lg">Years of Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}